// extracted by css-extract-rspack-plugin
export default {"calendar":"oRACcFPT5yso9_uz","grid":"J2oZMuSm3iYpfi9x","cell":"JkSf422WqpE6ntgK","range":"YjR_touBXVcKYGvN","picker":"SvEEgF5oewq5zEjc","today":"rcBvzPx_fESdE7U8"};